import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import { Account } from "@bn/api/apiv1";
import { AccountsTable } from "./AccountsTable";

type Props = {
  accounts?: Account[];
  onConfirm: () => void;
  onSelect: (ids: number[]) => void;
  checkedPortfolios: number[];
  onClose?: () => void;
};

export const DepotsSelectorBody = ({
  accounts,
  checkedPortfolios = [],
  onSelect,
  onConfirm,
  onClose,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" height="calc(100% - 70px)">
      <AccountsTable
        accounts={accounts}
        checkedPortfolios={checkedPortfolios}
        onSelect={onSelect}
      />
      <Box display="flex" justifyContent="space-between" gap={3}>
        <Button variant="tertiary" onClick={onClose}>
          {t("navigation.previous")}
        </Button>
        <Button
          data-testid="create-depots-list"
          variant="primary"
          onClick={onConfirm}
          disabled={!checkedPortfolios.length}
        >
          {t("depotsSelect.saveButton")}
        </Button>
      </Box>
    </Box>
  );
};
